// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useCustomerConfig } from '@store';

import { css } from '@emotion/css';
import { useTheme, Tooltip, Theme } from '@mui/material';

import { BiSolidInfoCircle } from 'react-icons/bi';

// COMPONENT ---------------------------------------------------------------- //

const SearchCriteriaIcon = () => {
  const theme = useTheme();
  const cls = useStyles(theme);

  const customerConfig = useCustomerConfig();
  const refLabel = customerConfig?.reference_num_label || 'Reference ID';

  return (
    <Tooltip
      title={
        <div className={cls.infoTooltipContent}>
          <div className={cls.infoTooltipTitle}>Search by criteria:</div>
          <div>• HopDrive Move ID</div>
          <div>• {refLabel}</div>
          <div>• Vehicle VIN</div>
          <div>• Vehicle Stock</div>
          <div>• Vehicle Make</div>
          <div>• Vehicle Model</div>
          <div>• Vehicle Year</div>
          <div>• Location Name</div>
          <div>• Location Address</div>
          <div>• Rooftop Name</div>
          <div>• Customer Name</div>
          <div>• Customer Phone</div>
        </div>
      }
      arrow
    >
      <BiSolidInfoCircle className={cls.infoIcon} size={20} color={theme.palette.text.disabled} />
    </Tooltip>
  );
};

// STYLES ---------------------------------------------------------------- //

const useStyles = (theme: Theme) => ({
  infoIcon: css`
    display: flex;
    cursor: pointer;
  `,
  infoTooltipContent: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 144px;
  `,
  infoTooltipTitle: css`
    margin-bottom: ${theme.spacing(1)};
    font-size: 14px;
    font-weight: 600;
  `,
});

// EXPORT ---------------------------------------------------------------- //

export default SearchCriteriaIcon;
